<template>
  <div class="tableshow-class smart-scroll">
    <div v-for="(item, index) in classList" :key="index" class="class-item-box">
      <Input
        v-model="item.className"
        type="textarea"
        autosize
        :rows="1"
        placeholder="请输入课班名称"
        class="class-input"
      ></Input>
      <div class="class-info">
        <span class="class-info-item">学生人数：{{ item.studentInfos.length }}人</span>
        <span class="class-info-item">
          <ChooseTeacherForForm
            :show-handle-icon="true"
            :school-id="schoolId"
            :apply-id="orgId"
            :parent-teacher-list="item.teacherInfo"
            @postTeacherData="getSelectTeacherData($event, index)"
          ></ChooseTeacherForForm>
        </span>
        <span class="class-info-item">
          上课场地：
          <PlaceSelect
            v-model="item.placeInfo"
            class="class-form-item"
            :org-id="schoolId"
            :branch-id="branchId"
          ></PlaceSelect>
          <!-- <PlaceModal
            v-model="item.placeInfo"
            :show-handle-icon="true"
            :org-id="schoolId"
            :should-classroom-id="false"
            :branch-id="branchId"
          ></PlaceModal> -->
        </span>
        <span class="class-info-items">
          上课时间：
          <div class="class-info-items-block">{{ item.timeDesc }}</div>
        </span>
      </div>
      <div
        class="class-right"
        :class="
          Object.keys(item.classStudentInfo).length === 0
            ? 'class-right-transparent'
            : ''
        "
      >
        <div
          v-for="(objValue, key) in item.classStudentInfo"
          :key="key"
          class="class-right-item"
        >
          <span class="class-name">{{ objValue.className }}（{{ objValue.list.length }}）</span>
          <span
            class="class-btn"
            @click="handleToChangeClass(objValue, index)"
          >转班</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PlaceSelect from '@pv/courseSchedulCenter/assets/components/PlaceSelect.vue';
import ChooseTeacherForForm from '@c/searchBlock/ChooseTeacherForForm.vue';
export default {
  components: {
    // PlaceModal,
    PlaceSelect,
    ChooseTeacherForForm
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }, // v-model的值
    // 选中班级
    activeClassIndex: {
      type: Number,
      default: 0
    },
    // 商品列表选中的index变化之后
    activeGoodsIndex: {
      type: Number,
      default: 0
    },
    schoolId: {
      type: String,
      default: ''
    }, // 学校id
    branchId: {
      type: String,
      default: ''
    }, // 校区id
    orgId: {
      type: String,
      default: ''
    } // 资源提供方id
  },
  data() {
    return {};
  },
  computed: {
    classList: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }
  },
  watch: {
    activeGoodsIndex() {
      this.$emit('update:activeClassIndex', 0);
    }
  },
  methods: {
    handleToChangeClass(value, index) {
      this.$emit('update:activeClassIndex', index);
      const studentIds = value.list.map(item => {
        return item.studentId;
      });
      this.$emit('showChangeModal', studentIds);
    },
    getSelectTeacherData(list, index) {
      console.log(list, index, '教师列表');
      this.classList[this.activeClassIndex].teacherIds = list.map(item => {
        return item.userId;
      });
      this.classList[this.activeClassIndex].teacherInfo = list.map(item => {
        return {
          teacherId: item.userId,
          teacherName: item.userName
        };
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.class-form-item {
    width: 120px;
  }
.smart-scroll {
  scrollbar-width: thin; //火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细
  &::-webkit-scrollbar {
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    width: 4px;
    height: 60px;
    background: rgba(0, 0, 0, 0.15);
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background: rgba(255, 255, 255, 0);
  }
}
.tableshow-class {
  height: calc(100% - 48px);
  overflow-y: auto;
  padding-right: 24px;
  .class-item-box + .class-item-box {
    margin-top: 16px;
  }
  .class-item-box {
    padding: 8px;
    background: #f7f7f9;
    display: flex;
    align-items: center;
    .class-input {
      width: 220px;
    }
    .class-info {
      flex: 1;
      display: flex;
      align-items: center;
      padding: 0 8px;
      .class-info-item {
        width: 18%;
        margin-right: 2%;
        display: flex;
        align-items: center;
      }
      .class-info-items {
        width: 40%;
        display: flex;
        align-items: center;
        .class-info-items-block {
          width: 70%;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
        }
      }
    }
    .class-right {
      width: 226px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #dcdee2;
      .class-right-item {
        padding: 10px 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .class-btn {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #488ffa;
          line-height: 20px;
          cursor: pointer;
        }
      }
      .class-right-item + .class-right-item {
        border-top: 1px solid #dcdee2;
      }
    }
    .class-right-transparent {
      opacity: 0;
    }
  }
}
</style>
